//@ts-ignore
//@ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useForm, FormContext, Controller } from "react-hook-form";
import NumberFormat from "react-number-format";

import {
  addContractorWorkData,
  addInsuredWorkData,
  addWorkData,
  modalSteps,
  stepPosition,
} from "../../Store/simulate/actions";
import {
  validatePhoneVoid,
  validateEmail,
  validatorField,
  validateTextOnlyAlphanumeric,
} from "../../Utils/validators";
import useBeforeFirstRender from "../../customHook/useBeforFirstRenderQuote";

import Button from "../../Components/FormElements/Button";
import FormTitle from "../../Components/FormElements/FormTitle";
import NavCase from "../../Components/FormElements/NavCase";
import Title from "../../Components/FormElements/Title";
import ErrorCustom from "../../Components/errorCustom";
import NavResponsive from "../../Components/FormElements/NavResponsive";
import Footer from "../../Components/Footer";

import BreadCrumbs from "../BreadCrumbs";
import IconBack from "../../Resources/svg/Icons/IconBack";

import ModalSteps from "./FormElements/ModalSteps";
import { InsuredForm, ContractorForm } from "../../Components/stepperComponents/workData";
import TabTitle from "../../Components/tabTitle";

export const WorkData = () => {
  const dataStoreClient = useSelector((state: any) => state.simulate.policy.client);
  const dataStoreWork = useSelector((state: any) => state.simulate.policy.workData);
  let dataRedux;
  if (Object.entries(dataStoreWork).length !== 0) {
    dataRedux = dataStoreWork;
  }
  const { asegurado, contratante } = dataStoreClient;

  const [loadingClick, setLoadingClick] = useState<any>(false);
  const methods = useForm({ mode: "onChange" });

  const [ activeTab, setActiveTab ] = useState('insured');

  const [formInsuredValid, setFormInsuredValid] = useState<bolean | null>(false);
  const [formContractorValid, setFormContractorValid] = useState<boolean | null>(false);

  const CONTRACTOR_EQUAL_INSURED = Object.keys(contratante).length === 0;
  const CONTRACTOR_DIFF_INSURED = Object.keys(contratante).length !== 0;

  const {
    register,
    control,
    watch,
    errors,
    handleSubmit,
    formState: { isValid },
  } = methods;
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = (data: any, profileType: string) => {
    setLoadingClick(true);
    const { isRetired, otherCharge, ...values } = data;
    const dataWork = {
      ...values /*,
      address,*/,
    };
    
    if(profileType === 'INSURED'){
      if(isRetired || otherCharge) data.address = {};
      dispatch(addWorkData(dataWork));
      dispatch(addInsuredWorkData({...dataWork}));
      if(CONTRACTOR_EQUAL_INSURED){
        setTimeout(() => {
          setLoadingClick(false);
          history.push("/cotizaciones/declaracion-de-salud");
          dispatch(stepPosition(3));
        }, 500);
      } else if(CONTRACTOR_DIFF_INSURED){
        setLoadingClick(false);
        setActiveTab('contractor');
        window.scrollTo(0, 0);
      } 
    } else if (profileType === 'CONTRACTOR'){
      dispatch(addContractorWorkData({...dataWork}));
      setTimeout(() => {
        setLoadingClick(false);
        history.push("/cotizaciones/declaracion-de-salud");
        dispatch(stepPosition(3));
      }, 500);
    }
  };

  useBeforeFirstRender(dataStoreClient);

  const handleOpenModal = () => {
    dispatch(modalSteps(true));
  };

  return (
    <>
      <div className="wrap">
        <NavResponsive position={2} title="Datos laborales" />
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Simulaciones" }, { link: "Cotización" }]}
            />
            <div className="nav-case__routing">
              <IconBack className="nav-case__back" onClick={handleOpenModal} />
              <div className="nav-case__title">Datos laborales</div>
              <NavCase />
            </div>
          </div>
          <div className="form-register">
            { CONTRACTOR_DIFF_INSURED && <div className="detailsTab__tabs-maxwidth">
              <TabTitle id={'Asegurado'} onClick={(e: any) => dataRedux ?  setActiveTab('insured') : false } defaultChecked={ activeTab === 'insured' ? true : null} disabled={dataRedux ? false : true} />
              <TabTitle id={'Contratante'} onClick={(e: any) => dataRedux ?  setActiveTab('contractor') : false } defaultChecked={ activeTab === 'contractor' ? true : null} disabled={dataRedux ? false : true} />
            </div> }

            {activeTab === 'insured' && <InsuredForm setFormInsuredValid={setFormInsuredValid} loading={loadingClick} onSubmit={(values: any) => onSubmit(values, 'INSURED')} />}
            {activeTab === 'contractor' && <ContractorForm setFormContractorValid={setFormContractorValid} loading={loadingClick} onSubmit={(values: any) => onSubmit(values, 'CONTRACTOR')} />}
          </div>
        </div>
      </div>
      <ModalSteps />
      <Footer />
    </>
  );
};
